// extracted by mini-css-extract-plugin
module.exports = {"InnerNavigation":"MobileInnerNavigation_InnerNavigation__28X-Y"};